import { useContext } from 'react';

import { ThemeContext } from '~store/Theme/ThemeContext';

export function useTheme() {
  return useContext(ThemeContext);
}
